import { Controller } from "@hotwired/stimulus";

// Maneja el array de palabras clave del AutoDM (chips + add/remove client-side).
// Las palabras se persisten como hidden inputs `name="autodm_form[words][]"`.
//
// Equivalente a AutoDmFormKeys.tsx + immutability-helper $push/$splice.
//
// Estructura del DOM (ver _keywords.html.erb):
//   <div data-controller="manage--autodm--keywords">
//     <div data-manage--autodm--keywords-target="list">
//       <!-- chips con <input type="hidden" name="autodm_form[words][]"> -->
//     </div>
//     <div data-manage--autodm--keywords-target="inputBlock" class="hidden">
//       <input data-manage--autodm--keywords-target="input">
//       <button data-action="click->manage--autodm--keywords#add">Agregar</button>
//     </div>
//     <button data-manage--autodm--keywords-target="addBtn"
//             data-action="click->manage--autodm--keywords#showInput">Agregar palabra</button>
//     <template data-manage--autodm--keywords-target="template"> ...chip skeleton... </template>
//   </div>

export default class extends Controller {
  static targets = ["list", "input", "inputBlock", "addBtn", "template"];

  showInput(event) {
    event.preventDefault();
    this.inputBlockTarget.style.display = "";
    this.addBtnTarget.style.display = "none";
    this.inputTarget.value = "";
    this.inputTarget.focus();
  }

  add(event) {
    event.preventDefault();
    const word = (this.inputTarget.value || "").trim();
    if (!word) return;
    this._appendChip(word);
    this._hideInput();
  }

  addOnEnter(event) {
    event.preventDefault();
    this.add(event);
  }

  remove(event) {
    event.preventDefault();
    const chip = event.currentTarget.closest("[data-manage--autodm--keywords-target='chip']");
    if (chip) chip.remove();
  }

  _appendChip(word) {
    const tpl = this.templateTarget;
    const fragment = tpl.content.cloneNode(true);
    fragment.querySelector("[data-chip-label]").textContent = word;
    fragment.querySelector("[data-chip-input]").value = word;
    this.listTarget.appendChild(fragment);
  }

  _hideInput() {
    this.inputBlockTarget.style.display = "none";
    this.addBtnTarget.style.display = "";
    this.inputTarget.value = "";
  }
}
